/**
 * @summary - Component that Provides Item Details Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { FemsGraph, MasterGraph,BemsGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
async function getPpmGenerationList(value) {
  const response = await Axios.post(`${FemsGraph}/api/GraphPPMGeneration/GetPPMGenerationList?size=1000`, value);
  return response;
}


async function getDetailsList(facilityId) {
  const response = await Axios.get(`${FemsGraph}/api/graph/GetUserLocationDetailsByFacilityId/${facilityId}?size=1000`);
  return response;
}
async function getItemType(facilityId) {
    const response = await Axios.get(`${MasterGraph}/api/masimsitemtypes?size=1000`);  
    if (response?.status !== 'error') {
      const reArrangedData = ReArrangeLabel(response?.data, "itemType", "label");
      return reArrangedData;
    }
    return response;
  }

  async function getItemDetailsList(facilityId,filterModel=[],sortModel=[],pageIndex=1,pageSize=5000) {


    const response = await Axios.get(`${MasterGraph}/api/GraphItemDetails/GetItemdetailsByFacilityId/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);  
    return response;
  }

  async function fetchExportdata(facilityId,filterModel=[],sortModel=[]) {


    const response = await Axios.get(`${MasterGraph}/api/GraphItemDetails/GetExportData/${facilityId}?filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);  
    return response;
  }

  async function getStore(facilityId) {
   const response = await Axios.get(`${MasterGraph}/api/GraphItemDetails/Getwarhousedetailsfacilityid/${facilityId}?size=1000`);
    if (response?.status !== 'error') {
      const reArrangedData = ReArrangeLabel(response?.data, "warehousedesc", "label");
      return reArrangedData;
    }
    return response;
  }


  async function createItemDetails(item) { 
    const response = await Axios.post(`${MasterGraph}/api/masimscompanyitemdetails`,item); 
     return response;
   }
   async function updateItemDetails(item,Id) { 
    let values={...item,id:Id};
    const response = await Axios.update(`${MasterGraph}/api/masimscompanyitemdetails/${Id}`,values); 

     return response;
   }
   async function removeItemDetails(id) { 
    const response = await Axios.remove(`${MasterGraph}/api/masimscompanyitemdetails/${id}`); 
     return response;
   }

const itemDetailsRepository = {
  getPpmGenerationList,
  getDetailsList,
  getItemType,
  getStore,
  createItemDetails,
  updateItemDetails,
  getItemDetailsList,
  removeItemDetails,
  fetchExportdata

};


export default itemDetailsRepository;
